import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "../../../Process/services/processInformationService";
import {
  ProcessGroup,
  ProcessInformation,
} from "../../../Process/model/ProcessGroups";
import {
  getProcessDetailState,
  getProcessState,
} from "../../../Process/config";
import { addRoute as addNotesRoutes } from "../../../Process/views/processDetail/notes/route";

processRouteConfig.$inject = ["$stateProvider"];

export function processRouteConfig($stateProvider: StateProvider) {
  $stateProvider
    .state(
      "main.machines.process",
      getProcessState(
        "machine",
        Symbol(`main.machines.process`),
        [() => {}],
        [
          ProcessInformationServiceName,
          "processGroup",
          "$state",
          (
            processInformationService: ProcessInformationService,
            processGroup: ProcessGroup,
            $state: StateService
          ) => [
            "process",
            (process: ProcessInformation) =>
              processInformationService
                .createNewProcessFlow(processGroup, process)
                .then((processResponse) =>
                  $state.go(".detail", {
                    processInstancesId: processResponse.Id,
                  })
                ),
          ],
        ],
        [
          "processGroup",
          ProcessInformationServiceName,
          (
            processGroup: ProcessGroup,
            processInformationService: ProcessInformationService
          ) => [
            ...processInformationService.getAdditionalGridColumns(processGroup),
          ],
        ]
      )
    )
    .state(
      "main.machines.process.detail",
      getProcessDetailState([
        "processGroup",
        ProcessInformationServiceName,
        (
          processGroup: ProcessGroup,
          processInformationService: ProcessInformationService
        ) => processInformationService.getDetailTemplate(processGroup.Id),
      ])
    );
  addNotesRoutes($stateProvider, "main.machines.process.detail.notes");
}
